export const CARTPRODUCTADD = "cart/productAdd";
export const CARTPRODUCTREMOVE = "cart/productRemove";
export const CARTQTYINCREMENT = "cart/productQtyIncrement";
export const CARTQTYDECREMENT = "cart/productQtyDecrement";
